import Modal from "react-bootstrap/Modal";
import styles from "./LimitOrDeleteModal.module.css";
import { useTranslation } from "react-i18next";

function SendInvite({ show, handleClose, setSearchKeyword }) {
  const { t } = useTranslation();
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{ background: "#F5F4F4" }}>
          <Modal.Title>
            <div className={styles.modalHead}>
              <p>
                {" "}
                {t("SEND")} <span>{t("INVITE_")}</span>
              </p>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalBody}>
            <p>
              {t("INVITE_HAS_BEEN")} <span>{t("SENT_SUCCESSFULLY")}</span>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#F5F4F4" }}>
          <div className={styles.btnSection}>
            <button
              className={styles.close}
              onClick={() => {
                handleClose();
                // setSearchKeyword("");
              }}
            >
              {t("CLOSE")}
            </button>
            <button
              className={styles.delete}
              onClick={() => {
                handleClose();
                // setSearchKeyword("");
              }}
            >
              <p>
                {t("SEND")} <span>{t("ANOTHER")}</span>
              </p>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendInvite;
